export const German = {
  Features: "Funktionen",
  Blog: "Blog",
  Trade: "Handel",
  trade: "handel",
  Buy: "Kaufen/Verkaufen",
  Download: "Herunterladen",
  The: "Die",
  gateway: "Gateway",
  to: "zu",
  To: "Zu",
  the: "der",
  next: "nächsten",
  generation: "Generation",
  of: "von",
  Gamers: "Spielern",
  Your: "Ihre",
  games: "Spiele",
  coins: "Münzen",
  All: "Alle",
  in: "in",
  one: "einem",
  place: "Ort",
  Simple: "Einfach",
  fun: "Spaß",
  and: "und",
  And: "Und",
  super: "super",
  smart: "intelligent",
  Scan: "Scannen",
  download: "herunterladen",
  app: "App",
  Available: "Verfügbar",
  on: "auf",
  assets: "Vermögenswerte",
  Assets: "Vermögenswerte",
  Game: "Spiel",
  game: "Spiel",
  Connect: "Verbinden",
  thirdparty: "Drittanbieter",
  Crypto: "Krypto",
  Card: "Karte",
  Authentication: "Authentifizierung",
  Own: "Eigenes",
  your: "Ihr",
  earn: "verdienen",
  is: "ist",
  Is: "Ist",
  easy: "einfach",
  way: "Weg",
  store: "speichern",
  manage: "verwalten",
  winnings: "Gewinne",
  Whether: "Ob",
  youre: "Sie sind",
  Youre: "Sie sind",
  competitive: "wettbewerbsfähig",
  gamer: "Spieler",
  or: "oder",
  just: "nur",
  casual: "gelegentlicher",
  player: "Spieler",
  has: "hat",
  something: "etwas",
  for: "für",
  everyone: "jeden",
  effortlessly: "mühelos",
  converts: "konvertiert",
  into: "in",
  preferred: "bevorzugte",
  cryptocurrency: "Kryptowährung",
  start: "beginnen",
  earning: "verdienen",
  Exclusive: "Exklusiv",
  content: "Inhalt",
  experiences: "Erfahrungen",
  now: "jetzt",
  at: "an",
  fingertips: "Fingerspitzen",
  passport: "Pass",
  unlock: "entsperren",
  favourite: "Lieblings-",
  need: "benötigen",
  do: "tun",
  connect: "verbinden",
  any: "jede",
  other: "andere",
  Gaming: "Spiele",
  Platform: "Plattform",
  account: "Konto",
  Once: "Einmal",
  connected: "verbunden",
  youll: "werden Sie",
  Youll: "Sie werden",
  be: "sein",
  able: "in der Lage",
  rewards: "Belohnungen",
  unlocking: "entsperren",
  instantly: "sofort",
  enjoying: "genießen",
  powered: "betrieben",
  by: "von",
  will: "werden",
  launch: "starten",
  token: "Token",
  listing: "Auflistung",
  major: "wichtige",
  coming: "kommende",
  soon: "bald",
  participate: "teilnehmen",
  our: "unser",
  premium: "Premium-",
  collections: "Sammlungen",
  you: "Sie",
  You: "Sie",
  must: "müssen",
  signup: "anmelden",
  get: "erhalten",
  verified: "verifiziert",
  buy: "kaufen",
  using: "verwenden",
  respectively: "entsprechend",
  Smartest: "Intelligenteste",
  Safe: "Sicher",
  Secure: "Sicher",
  Earn: "Verdienen",
  Big: "Groß",
  Join: "Beitreten",
  Trend: "Trend",
  Dont: "Nicht",
  left: "übrig",
  behind: "zurück",
  Welcome: "Willkommen",
  world: "Welt",
  possibilities: "Möglichkeiten",
  space: "Raum",
  no: "kein",
  longer: "länger",
  thing: "Sache",
  it: "es",
  present: "präsentieren",
  Over: "Über",
  invested: "investiert",
  projects: "Projekte",
  past: "Vergangenheit",
  year: "Jahr",
  free: "kostenlos",
  easiest: "einfachste",
  anywhere: "überall",
  anytime: "jederzeit",
  Use: "Verwenden",
  accepted: "akzeptiert",
  from: "von",
  online: "online",
  globally: "weltweit",
  With: "Mit",
  an: "einem",
  instant: "sofortigen",
  cash: "Bargeld",
  conversions: "Umwandlungen",
  can: "kann",
  spend: "ausgeben",
  without: "ohne",
  hassles: "Schwierigkeiten",
  top: "Spitzen-",
  notch: "Qualitäts-",
  security: "Sicherheit",
  blockchain: "Blockchain",
  backbone: "Grundgerüst",
  are: "sind",
  always: "immer",
  safe: "sicher",
  perfect: "perfekt",
  most: "meisten",
  out: "aus",
  Rewarding: "Belohnend",
  complete: "vollständig",
  control: "Steuerung",
  over: "über",
  funds: "Fonds",
  while: "während",
  prioritizing: "Priorisierung",
  gaming: "Spielen",
  back: "zurück",
  with: "mit",
  every: "jedem",
  use: "Verwendung",
  today: "heute",
  level: "Niveau",
  up: "hoch",
  rules: "Regeln",
  only: "nur",
  keys: "Schlüssel",
  so: "so",
  Our: "Unsere",
  audited: "geprüft",
  audit: "Prüfung",
  firms: "Unternehmen",
  constantly: "ständig",
  reviewed: "überprüft",
  ensure: "sichern",
  maximum: "maximal",
  Convenience: "Bequemlichkeit",
  moment: "Moment",
  WAYS: "WEGE",
  AUTHENTICATION: "AUTHENTIFIZIERUNG",
  TO: "ZU",
  STRENGTHEN: "STÄRKEN",
  YOUR: "IHRE",
  ASSETS: "VERMÖGENSWERTE",
  SAFETY: "SICHERHEIT",
  enjoy: "genießen",
  all: "alle",
  this: "dies",
  amazing: "erstaunlich",
  functionalities: "Funktionalitäten",
  A: "Eine",
  Decentralized: "Dezentralisierte",
  wallet: "Brieftasche",
  dedicated: "gewidmet",
  Home: "Zuhause",
  Marketplace: "Marktplatz",
  Privacy: "Datenschutz",
  Policy: "Richtlinie",
  Terms: "Geschäftsbedingungen",
  Service: "Service",
  Navigation: "Navigation",
  Products: "Produkte",
  Legal: "Rechtlich",
  What: "Was",
  How: "Wie",
  blockchains: "blockchains",
  does: "tut",
  support: "Unterstützung",
  types: "Typen",
  deposit: "Kaution",
  withdraw: "zurückziehen",
  earned: "verdient",
  my: "Mein",
  I: "ICH",
};
